import { styled } from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import AllocatedEventsPopover from './AllocatedEventsPopover'

type AvailabilityInfoProps = {
  user: any
}

const AvailabilityInfo = ({ user }: AvailabilityInfoProps) => {
  const { t } = useTranslation()

  let allocationStatus = ''

  const isGreen =
    user.absences?.length === 0 &&
    !user.selected &&
    user.availabilityPreference &&
    user.allocated?.length === 0

  if (user.absences?.length > 1) {
    allocationStatus = t('MULTIPLE_ABSENCES')
  } else if (user.absences?.length === 1) {
    allocationStatus = user.absences[0].name
  } else if (user.selected || user.allocated?.length > 0) {
    allocationStatus = t('ALLOCATED')
  } else {
    allocationStatus = t('AVAILABLE')
  }

  return (
    <SectionWrapper green={isGreen}>
      {user.allocated?.length > 0 ? (
        <AllocatedEventsPopover events={user.allocated}>
          <Text weight={isGreen ? 'medium' : undefined}>
            {allocationStatus}
          </Text>
        </AllocatedEventsPopover>
      ) : (
        <Text weight={isGreen ? 'medium' : undefined}>{allocationStatus}</Text>
      )}

      {user.availabilityPreference && user.absences?.length === 0 && (
        <Text level={2}>{t('PREFERRED_TIME')}</Text>
      )}

      {(user.clockedIn || user.clockedInToOtherInstance) && (
        <Text level={2}>{t('CLOCKED_IN')}</Text>
      )}
    </SectionWrapper>
  )
}

const SectionWrapper = styled.div<{ green?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  color: ${(props) =>
    props.green
      ? props.theme.color.status.success
      : props.theme.color.neutral.color3};
`
export default AvailabilityInfo
